import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectOneUsersQueryItems } from '../../../../../redux/one-users/selector';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { oneUsers } from '../../../../../redux/one-users/action';
import PageLoader from '../../../../../components/PageLoader';
import { OneUserComponent } from '../components/one-user.component';
import { tagNames } from '../../../../../redux/tag-names/action';
import { selectTagNamesListItems } from '../../../../../redux/tag-names/selector';
import { setDisplayText } from '../../../../../service/tag-names.service';
import { selectTagsListItems } from '../../../../../redux/tags/selector';
import { tags } from '../../../../../redux/tags/action';


const OneUser = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const oneUserItems = useSelector(selectOneUsersQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const tagNameListItems = useSelector(selectTagNamesListItems)
  const tagentityMappingslist = useSelector(selectTagsListItems)
  const [selectedOneUser, setSelectedOneUser] = useState<any>([])
  const fetchTagEntityMapping = async (contactId: number) => {
    await dispatch(tags.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-entity-mappings/list`,
      entity: 'tagMapping',
      jsonData: {
        Filters: [
          {
            FieldName: 'OwnerType',
            FieldType: 'text',
            FilterOperatorId: 1,
            FieldValue: 'ONEUser'
          },
          {
            FieldName: 'OwnerId',
            FieldType: 'number',
            FilterOperatorId: 1,
            FieldValue: contactId
          }
        ]
      }
    }));
  };
  const fetchTags = () => {
    dispatch(tagNames.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-values/list`,
      entity: 'tagNames',
      jsonData: {}
    }))
  }
  const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({
    PrimaryAddress: {},
  })

  const fetchOneUserById = async () => {

    await dispatch(oneUsers.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/query`, entity: 'oneUsers', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    }))
    await fetchTagEntityMapping(parmas?.id);
    await setIsQuery(true)


  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field

    );
    const value = { ...data, [fields[1]]: event }
    setSelectedOneUser({ ...selectedOneUser, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }

  const handleBasicInnerFormChange: any = (event: any, field: string) => {
    setSelectedOneUser({ ...selectedOneUser, [field]: event })
  }
  useEffect(
    () => {
      dispatch(oneUsers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,
        entity: 'oneUsers',
        jsonData: {}
      })).then(() => {
        dispatch(tagNames.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
          entity: 'tagNames',
          jsonData: {}
        }))
      }).then(() => {

        if (parmas?.id > 0) {
          fetchOneUserById()
          setIsLoading(false)
          fetchTags()
        } else {
          setIsLoading(false)
        }
      })


    },
    []
  )

  useEffect(
    () => {

      if (isQuery) {
        setSelectedOneUser(oneUserItems?.result?.items)
      }
    },
    [isQuery]
  )
  useEffect(
    () => {
      if (isQuery && tagentityMappingslist) {
        const onesuer = oneUserItems?.result?.items;
        const tagMapping = tagentityMappingslist?.result?.items?.[0];

        if (onesuer) {
          setSelectedOneUser({
            ...onesuer,
            TagEntityMappingsValueIds: tagMapping?.Id ?? ''
          });
        }
        else {
          setSelectedOneUser(oneUserItems?.result?.items)
        }
      }
    }, [isQuery, tagentityMappingslist]
  )


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {

      await dispatch(oneUsers.resetAction({ actionType: 'update' }))
      if (selectedOneUser?.TagEntityMappingsValueIds) {
        dispatch(tags.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-entity-mappings`,
          entity: 'tags',
          jsonData: {
            Records: [

              { "ValueId": selectedOneUser?.TagEntityMappingsValueIds, "EntityId": parmas?.id, "EntityType": "ONEUser", "EntityTypeId": 8 }

            ]
          }
        }))
      }
      await dispatch(oneUsers.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'oneUsers',
        jsonData: {

          Records: [
            {
              ...selectedOneUser

            }

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(oneUsers.resetAction({ actionType: 'create' }))
      await dispatch(oneUsers.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'oneUsers',
        jsonData: {

          Records: [
            {
              ...selectedOneUser
            }
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/agencies/sales/oneuser')
  }

  const basicHandleTags: any = (event: any, field: string) => {
    setSelectedOneUser({ ...selectedOneUser, [field]: event })
  }
  return (
    <>
      {isLoading ? <PageLoader /> :
        <OneUserComponent
          handleBasicInnerFormChange={handleBasicInnerFormChange}
          handleInnerFormChange={handleInnerFormChange}
          selectedOneUser={selectedOneUser}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedAddress={selectedAddress}
          tagNames={setDisplayText(tagNameListItems?.result?.items)}
          id={parmas?.id}
          tags={setDisplayText(tagentityMappingslist?.result?.items)}
          basicHandleTags={basicHandleTags}
        />
      }
    </>
  )

}

export default OneUser;